import * as bufferhandling from './bufferhandling.js';
import * as plugins from './smartjson.plugins.js';

export const stableStringify = (valueArg: any): string => {
  const normalizedValue = JSON.parse(bufferhandling.stringify(valueArg));
  let canUseNativeStringify = true;

  const createSortedValue = (valueArg: any): any => {
    if (Array.isArray(valueArg)) {
      return valueArg.map((itemArg) => createSortedValue(itemArg));
    }
    if (valueArg === null || typeof valueArg !== 'object') return valueArg;

    const keys = Object.keys(valueArg).sort();
    const sortedValue: Record<string, any> = {};
    for (const key of keys) {
      const sortedItem = createSortedValue(valueArg[key]);
      if (key in sortedValue) {
        Object.defineProperty(sortedValue, key, {
          configurable: true,
          enumerable: true,
          value: sortedItem,
          writable: true,
        });
      } else {
        sortedValue[key] = sortedItem;
      }
    }

    const nativeKeys = Object.keys(sortedValue);
    if (
      nativeKeys.length !== keys.length
      || nativeKeys.some((keyArg, indexArg) => keyArg !== keys[indexArg])
    ) {
      canUseNativeStringify = false;
    }
    return sortedValue;
  };

  const sortedValue = createSortedValue(normalizedValue);
  if (!canUseNativeStringify) return plugins.stableJson(normalizedValue, {});
  return JSON.stringify(sortedValue);
};
